module.exports = __webpack_public_path__ + "img/legende300.2a99bf10.jpg";